// ABOUTME: Shows the operational readiness of a WhatsApp pre-registration configuration.
// ABOUTME: Separates saved configuration activation from the company rollout release.
import React from "react";
import {
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Typography
} from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";

import { WhatsappPreRegistrationLabels } from "./whatsappPreRegistrationLabels";
import {
    WhatsappPreRegistrationSetupStep,
    WhatsappPreRegistrationSetupStepId
} from "./whatsappPreRegistrationSettingsModel";

interface WhatsappPreRegistrationSetupGuideProps {
    steps: WhatsappPreRegistrationSetupStep[];
    labels: WhatsappPreRegistrationLabels;
}

const getStepLabels = (
    labels: WhatsappPreRegistrationLabels,
    id: WhatsappPreRegistrationSetupStepId
) => {
    const stepLabels: Record<
        WhatsappPreRegistrationSetupStepId,
        { title: string; pending: string; complete: string }
    > = {
        integration: {
            title: labels.setupIntegrationTitle,
            pending: labels.setupIntegrationPending,
            complete: labels.setupIntegrationComplete
        },
        destinations: {
            title: labels.setupDestinationsTitle,
            pending: labels.setupDestinationsPending,
            complete: labels.setupDestinationsComplete
        },
        routing: {
            title: labels.setupRoutingTitle,
            pending: labels.setupRoutingPending,
            complete: labels.setupRoutingComplete
        },
        owners: {
            title: labels.setupOwnersTitle,
            pending: labels.setupOwnersPending,
            complete: labels.setupOwnersComplete
        },
        save: {
            title: labels.setupSaveTitle,
            pending: labels.setupSavePending,
            complete: labels.setupSaveComplete
        },
        rollout: {
            title: labels.setupRolloutTitle,
            pending: labels.setupRolloutPending,
            complete: labels.setupRolloutComplete
        }
    };
    return stepLabels[id];
};

const WhatsappPreRegistrationSetupGuide = ({
    steps,
    labels
}: WhatsappPreRegistrationSetupGuideProps) => (
    <Paper elevation={0} style={{ padding: 24 }}>
        <Typography variant="h6">{labels.setupGuideTitle}</Typography>
        <Typography variant="body2" color="textSecondary">
            {labels.setupGuideDescription}
        </Typography>
        <List disablePadding>
            {steps.map((step) => {
                const stepLabels = getStepLabels(labels, step.id);
                return (
                    <ListItem
                        key={step.id}
                        disableGutters
                        alignItems="flex-start"
                    >
                        <ListItemIcon>
                            {step.complete ? (
                                <CheckCircleOutlineIcon color="primary" />
                            ) : (
                                <RadioButtonUncheckedIcon color="action" />
                            )}
                        </ListItemIcon>
                        <ListItemText
                            primary={stepLabels.title}
                            secondary={
                                step.complete
                                    ? stepLabels.complete
                                    : stepLabels.pending
                            }
                        />
                    </ListItem>
                );
            })}
        </List>
        <Box mt={1}>
            <Typography variant="caption" color="textSecondary">
                {labels.helpServerValidation}
            </Typography>
        </Box>
    </Paper>
);

export default WhatsappPreRegistrationSetupGuide;
